export const DEFAULT_PAGINATION_PARAM_LIMIT = 20;
export const DEFAULT_PAGINATION_PARAM_OFFSET = 0;
